import React from 'react';
import wbImg from "static/img/whistle_blowing_system.png";

import Head from 'next/head'

export default class extends React.Component {
	render() {
		return (
			<div>
				<Head>
					<title>Whistleblowing System </title>
				</Head>
				<div className="container">
				<div>
				<img src={wbImg} alt="Whistleblowing System" className="img-fluid" />
				</div>
					<div className="text-center my-5">
						<h5 className="text-primary font-weight-bold">Whistleblowing System </h5>
					</div>
					<div className="m-4 body">
						<p>
							PT Jasamarga Tollroad Operator (“JMTO”) terus melaksanakan penerapan prinsip-prinsip <i>Good Corporate Governance</i> (GCG) secara konsisten dan berkesinambungan dalam melaksanakan pengelolaan Perusahaan dengan penuh amanah, transparan dan akuntabel, serta senantiasa memenuhi ketentuan perundang-undangan yang berlaku.
						</p>
						<p>
							Sebagai wujud komitmen tersebut, Jasamarga Transjawa Tol menerapkan <i>Whistleblowing System</i> dalam rangka memberikan kesempatan kepada seluruh Insan JMTO dan stakeholders lainnya untuk dapat menyampaikan laporan mengenai dugaan pelanggaran terhadap prinsip-prinsip Tata Kelola Perusahaan yang baik, serta nilai-nilai etika yang berlaku, berdasarkan bukti-bukti yang dapat dipertanggungjawabkan serta dengan niat baik untuk kepentingan PT Jasamarga Tollroad Operator.
						</p>
						<p>
							Lingkup Pengaduan/Penyingkapan yang akan ditindaklanjuti oleh Tim Whistleblowing System PT Jasamarga Tollroad Operator adalah tindakan yang dapat merugikan PT Jasamarga Tollroad Operator, meliputi sebagai berikut:
						</p>
						<ol>
							<li>Penyimpangan dari peraturan dan perundangan yang berlaku;</li>
							<li>Penyalahgunaan jabatan untuk kepentingan lain di luar Perusahaan;</li>
							<li>Pemerasan;</li>
							<li>Perbuatan curang;</li>
							<li>Benturan Kepentingan;</li>
							<li>Gratifikasi;</li>
							<li>Penyuapan;</li>
							<li>Perbuatan yang melanggar etika, susila, dan norma kesopanan.</li>
						</ol>
						<p>
							Dengan melaporkan pelanggaran, Anda telah membantu mengurangi beban Perusahaan dengan menciptakan lingkungan kerja yang aman, adil dan jujur dalam bekerja.
						</p>
						<p>
							<i>Whistleblowing System</i> (“WBS”) PT Jasamarga Tollroad Operator dilaksanakan berdasarkan sistem pengelolaan WBS yang berlaku di PT Jasamarga Tollroad Operator melalui suatu keputusan bersama Direksi dan Komisaris dan telah mempertimbangkan sistem pengelolaan di induk perusahaan PT Jasa Marga (Persero) Tbk, yang dikelola secara profesional dan independen oleh PT Deloitte Advis Indonesia sehingga memberikan Anda kesempatan untuk melaporkan berbagai pelanggaran yang terjadi di PT Jasamarga Tollroad Operator dan termasuk dalam ruang lingkup pelanggaran yang dapat merugikan PT Jasamarga Tollroad Operator.
						</p>
						<p>
							Informasi tentang tata cara pengaduan penyalahgunaan wewenang atau pelanggaran yang dilakukan oleh pejabat badan publik maupun pihak yang mendapatkan izin atau perjanjian kerja dari badan publik yang bersangkutan dapat dilakukan sebagai berikut:
						</p>
						<ol>
							<li>
								Jika dokumen dan bukti-bukti yang disampaikan lengkap, Komisi Pelaporan Pelanggaran melakukan pemilahan data dan memutuskan apakah kasus tersebut dapat dilanjutkan ke tingkat penyelidikan.
							</li>
							<li>Jika keputusannya adalah cukup bukti, maka laporan tersebut akan ditingkatkan statusnya ke tahap penyelidikan.</li>
							<li>Laporan yang tidak terbukti akan dikembalikan kepada pelapor. Namun apabila terbukti, Komisi Pelaporan Pelanggaran akan melaporkan hasil temuannya tersebut kepada Direksi.</li>
							<li>Laporan yang berkaitan dengan jajaran manajemen di bawah Direksi disampaikan dalam bentuk surat dan ditujukan kepada Direktur Utama, sedangkan laporan-laporan yang berkaitan dengan Direksi akan ditujukan kepada Dewan Komisaris.</li>
							<li>
								Masyarakat dapat melakukan pengaduan melalui website dan email:
								<table>
									<tr>
										<td>Website</td>
										<td>:</td>
										<td><a target='_blank' href='https://idn.deloitte-halo.com/whistleblowing.tips/wbs/@jasamarga/'>https://idn.deloitte-halo.com/whistleblowing.tips/wbs/@jasamarga/</a></td>
									</tr>
									<tr>
										<td>Email</td>
										<td>:</td>
										<td><a href="mailto: jasamarga.wbs@tipoffs.info">jasamarga.wbs@tipoffs.info</a></td>
									</tr>
								</table>
							</li>
							<li>
								Masyarakat juga dapat melakukan pengaduan melalui Hotline dan Whatsapp serta PO BOX:
								<table>
									<tr>
										<td>Hotline</td>
										<td>:</td>
										<td><a href='tel:+62 21 3952 8855'>+62 21 3952 8855</a></td>
									</tr>
									<tr>
										<td>SMS</td>
										<td>:</td>
										<td><a href="sms:+62 8111978503">+62 8111978503</a></td>
									</tr>
									<tr>
										<td>Whatsapp</td>
										<td>:</td>
										<td><a target='_blank' href="https://api.whatsapp.com/send?phone=628111978503">+62 8111978503</a></td>
									</tr>
									<tr>
										<td>PO BOX</td>
										<td>:</td>
										<td>3025 JKP 10030</td>
									</tr>
								</table>
							</li>
						</ol>
						<p>
							Kebijakan Perusahaan tentang Whistleblowing System merujuk pada Keputusan Bersama Direksi dan Dewan Komisaris No. KEP 077/IX/2022 dan No. 112/KPTS/2022 Tentang Whistleblowing System PT Jasa Marga (Persero) Tbk dan telah diimplementasikan melalui penerbitan Surat Edaran Nomor: 01/SE-JMTO/I/2024 tentang Sistem Pelaporan Whistleblowing System di Lingkungan PT Jasamarga Tollroad Operator.
						</p>
					</div>
				</div>
				<style jsx>
					{`
                        .body{
                            font-weight:500;
                            font-size:.9em;
                            padding-bottom:2em;
							text-align:justify;
							text-justify:inter-word;
                        }
                        .body b{
                            margin: 1.5em 0;
                            display:block;
                        }
					`}
				</style>
			</div>
		);
	}
}
